module.exports = __webpack_public_path__ + "static/media/delete.5371f148.svg";